import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
import { createMemoStyles, safeRest, defaultBaseline, defaultFonts, deprecate, isControlled, uniqueId } from '@wds/utils';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var SIZES = /* #__PURE__ */Object.freeze(['lg', 'md', 'sm']);
/* #__PURE__ */

Object.freeze([].concat(_toConsumableArray(SIZES), ['xs']));
var INPUT_COLORS = /* #__PURE__ */Object.freeze(['success', 'warning', 'error']);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles$1 = createMemoStyles(function (theme) {
  var type = theme.type,
      spacing = theme.spacing,
      palette = theme.palette;
  return {
    wrenchLabel: function wrenchLabel(_ref) {
      var muted = _ref.muted,
          plain = _ref.plain;
      return _objectSpread$1(_objectSpread$1({
        display: 'block',
        color: palette.text.dark,
        fontFamily: type.fontFamily.base,
        '-webkit-font-smoothing': 'antialiased',
        boxSizing: 'border-box',
        fontSize: type.fontSize.bodySm,
        padding: 0,
        margin: [0, 0, spacing[2]],
        fontWeight: type.fontWeight.medium
      }, plain && {
        fontWeight: type.fontWeight.regular,
        fontSize: type.fontSize.body
      }), muted && {
        color: palette.text.darkMuted,
        fontWeight: type.fontWeight.regular
      });
    }
  };
});
var useStyles$2 = useStyles$1;
var _excluded$1 = ["children", "htmlFor", "muted", "plain"];

var Label = function Label(_ref) {
  var children = _ref.children,
      htmlFor = _ref.htmlFor,
      muted = _ref.muted,
      plain = _ref.plain,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  var theme = useTheme();

  var _useStyles = useStyles$2({
    theme: theme,
    muted: muted,
    plain: plain
  }),
      wrenchLabel = _useStyles.wrenchLabel;

  return /*#__PURE__*/React.createElement("label", Object.assign({
    className: wrenchLabel,
    htmlFor: htmlFor
  }, safeRest(rest)), children);
};

Label.displayName = "Label";
Label.propTypes = {
  children: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
  muted: PropTypes.bool,
  plain: PropTypes.bool
};
Label.defaultProps = {
  muted: false,
  plain: false
};
var Label$1 = Label;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles = createMemoStyles(function (theme) {
  var spacing = theme.spacing,
      shadow = theme.shadow,
      palette = theme.palette,
      type = theme.type,
      radius = theme.radius;
  var input = {
    height: {
      sm: spacing[6],
      md: 40,
      lg: spacing[7]
    },
    fontSize: type.fontSize.body,
    padding: {
      sm: spacing[2],
      md: spacing[4],
      lg: spacing[4]
    }
  };

  var getColor = function getColor(color, defaultColor) {
    // TO BE DEPRECATED - 'warning' will be removed
    if (color === 'error' || color === 'warning' || color === 'success') {
      return palette[color].main;
    }

    return defaultColor;
  };

  return {
    wrenchInput: function wrenchInput(_ref) {
      var size = _ref.size,
          stretched = _ref.stretched,
          color = _ref.color,
          disabled = _ref.disabled;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultBaseline), defaultFonts(theme)), {}, {
        outline: 'none',
        appearance: 'none',
        boxShadow: 'none',
        color: getColor(color, palette.text.dark),
        border: [1, 'solid', getColor(color, palette.border.main)],
        borderRadius: radius.small,
        backgroundColor: palette.background.light,
        lineHeight: 1.5,
        '&:hover': {
          borderColor: getColor(color, palette.border.hover),
          boxShadow: shadow.sky,
          transition: ['border-color 100ms', 'box-shawdow 100ms']
        },
        '&:focus': {
          borderColor: getColor(color, palette.border.active),
          transition: ['border-color', '100ms']
        },
        padding: [0, input.padding[size]],
        height: input.height[size]
      }, (size === 'md' || size === undefined) && {
        fontSize: input.fontSize
      }), stretched && {
        width: '100%'
      }), disabled && {
        pointerEvents: 'none',
        opacity: 0.4
      });
    },
    wrenchInputErrorMessage: function wrenchInputErrorMessage(_ref2) {
      var _palette$color;

      var color = _ref2.color;
      return _objectSpread(_objectSpread(_objectSpread({}, defaultBaseline), defaultFonts(theme)), {}, {
        marginTop: spacing[2],
        color: (_palette$color = palette[color]) === null || _palette$color === void 0 ? void 0 : _palette$color.main,
        fontSize: type.fontSize.bodySm,
        fontWeight: type.fontWeight.regular
      });
    }
  };
});

var InputErrorMessage = function InputErrorMessage(_ref) {
  var errorMessage = _ref.errorMessage,
      color = _ref.color;

  var _useStyles = useStyles({
    color: color
  }),
      wrenchInputErrorMessage = _useStyles.wrenchInputErrorMessage;

  if (!errorMessage && !color) return null;

  if (errorMessage && color === 'success') {
    throw new Error('Having an errorMessage and a success theme is not allowed');
  }

  return /*#__PURE__*/React.createElement("div", {
    role: "alert",
    className: wrenchInputErrorMessage
  }, errorMessage);
};

InputErrorMessage.displayName = "InputErrorMessage";
InputErrorMessage.propTypes = {
  /**
   * Color Variant
   */
  color: PropTypes.oneOf(INPUT_COLORS),

  /**
   * Error message for input validation
   */
  errorMessage: PropTypes.node
};
InputErrorMessage.defaultProps = {
  color: undefined,
  errorMessage: undefined
};
var _excluded = ["ariaLabel", "defaultValue", "disabled", "color", "errorMessage", "id", "inputSize", "label", "name", "onBlur", "onChange", "readOnly", "size", "stretched", "type", "value"];
var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      color = _ref.color,
      errorMessage = _ref.errorMessage,
      id = _ref.id,
      inputSize = _ref.inputSize,
      label = _ref.label,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly,
      size = _ref.size,
      stretched = _ref.stretched,
      type = _ref.type,
      value = _ref.value,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  deprecate({
    color: color
  }, 'color', 'warning', 'Input');
  var theme = useTheme();

  var _useStyles = useStyles({
    theme: theme,
    size: size,
    stretched: stretched,
    color: color,
    disabled: disabled
  }),
      wrenchInput = _useStyles.wrenchInput;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1]; // eslint-disable-next-line react-hooks/exhaustive-deps


  var isControlled$1 = useMemo(function () {
    return isControlled(value);
  }, []);
  var inputID = useMemo(function () {
    return id || uniqueId('input');
  }, [id]);

  var handleChange = function handleChange(event) {
    if (isControlled$1 && event.target.value !== value) {
      event.persist();
      setStateValue(event.target.value);

      if (onChange) {
        onChange(event);
      }
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, label ? /*#__PURE__*/React.createElement(Label$1, {
    htmlFor: inputID
  }, label) : null, /*#__PURE__*/React.createElement("input", Object.assign({
    "aria-label": ariaLabel,
    className: wrenchInput,
    defaultValue: defaultValue,
    id: inputID,
    name: name,
    onBlur: onBlur,
    onChange: handleChange,
    readOnly: readOnly,
    ref: ref,
    size: inputSize,
    type: type,
    value: isControlled$1 ? value : stateValue
  }, safeRest(otherProps))), errorMessage ? /*#__PURE__*/React.createElement(InputErrorMessage, {
    errorMessage: errorMessage,
    color: color
  }) : null);
});
Input.propTypes = {
  /**
   * Override for aria-label if it is different from label
   */
  ariaLabel: PropTypes.string,

  /**
   * Color variants
   */
  color: PropTypes.oneOf(INPUT_COLORS),

  /**
   * Provide default value on load
   */
  defaultValue: PropTypes.node,

  /**
   * If true, input is disabled from use
   */
  disabled: PropTypes.bool,

  /**
   * Provide an error message for validation
   */
  errorMessage: PropTypes.node,

  /**
   * identifier for input component
   */
  // eslint-disable-next-line consistent-return
  id: function id(props, propName) {
    if (typeof props[propName] !== 'string' && typeof props.label !== 'string' && typeof props.ariaLabel !== 'string') {
      return new Error('Accessibility Error: If `label` or `ariaLabel` is not provided the `id` prop is required.');
    }
  },

  /**
   * Maximum size of input value
   */
  inputSize: PropTypes.number,

  /**
   * It is best practice to compliment a text input with a label.
   */
  label: PropTypes.node,

  /**
   * Name attribute of the input
   */
  name: PropTypes.string,

  /**
   * onBlur handler
   * function(event: object) => void
   */
  onBlur: PropTypes.func,

  /**
   * onChange handler
   * function(event: object) => void
   */
  onChange: PropTypes.func,

  /**
   * If true, input values are read only and cannot be modified
   */
  readOnly: PropTypes.bool,

  /**
   * Input size variants
   */
  size: PropTypes.oneOf(SIZES),

  /**
   * If true will fit the full width of parent container
   */
  stretched: PropTypes.bool,

  /**
   * Type of the input element. Refer to https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types
   */
  type: PropTypes.string,

  /**
   * Value of input component
   */
  value: PropTypes.node
};
Input.defaultProps = {
  ariaLabel: undefined,
  color: undefined,
  defaultValue: undefined,
  disabled: false,
  errorMessage: undefined,
  id: undefined,
  inputSize: undefined,
  label: undefined,
  name: undefined,
  onBlur: undefined,
  onChange: undefined,
  readOnly: false,
  size: 'md',
  stretched: false,
  type: 'text',
  value: undefined
};
Input.displayName = 'Input';
export { Input };